import type { FC } from 'react';
import React from 'react';
import { TableCell, Typography } from '@mui/material';

import NumberDifference from 'src/components/dashboard/DashboardPage/components/NumberDifference';
import type { ComparisonValue } from 'src/components/followUp/common/types';

export type BarTableCellData = {
  stackLabel: string;
  color?: string;
  centeredScale?: boolean;
  hideBar?: boolean;
  percentage?: number | null;
} & ComparisonValue;

type BarTableCellWithHiddenBarProps = Pick<
  BarTableCellData,
  'color' | 'value' | 'comparison'
>;

const BarTableCellWithHiddenBar: FC<BarTableCellWithHiddenBarProps> = ({
  color,
  value,
  comparison,
}) => (
  <TableCell
    sx={{
      verticalAlign: 'top',
      textAlign: 'center',
    }}
  >
    <Typography
      component="span"
      color={color}
      display="inline-block"
      width="100%"
    >
      {value}

      {comparison && <NumberDifference comparisonDiff={comparison} showArrow />}
    </Typography>
  </TableCell>
);

export default BarTableCellWithHiddenBar;
